<template>
    <modal :name="modalName" width="100%" height="auto">
        <div class="p-3">
            <div class="text-center mt-3">
                <h3 id="modal-headline">
                    {{ $t("Please note") }}
                </h3>
                <div class="mt-2">
                    <p v-for="(error, index) in errors" :key="index" style="color: rgb(150, 35, 35)" class="text-center">
                        <span style="color: black" v-if="errors.length > 1">{{ index + 1 }}.</span>
                        {{ error.message }}
                    </p>
                </div>
            </div>
        </div>

        <hr>

        <div class="flex justify-content-center border-solid mt-4 pt-1 mb-4">
            <button class="btn btn-primary mr-2" v-on:click="$modal.hide(modalName)">{{ $t("Close") }}</button>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['errors', 'modalName']
}
</script>